var exports = {
  "N1": "ChannelHeader.module__headerContainer___THRHU1",
  "dL": "ChannelHeader.module__headerWrapper___THRHU1",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___THRHU1",
  "hE": "ChannelHeader.module__headerContainerCallActive___THRHU1",
  "Ud": "ChannelHeader.module__headerLeftSection___THRHU1",
  "Gv": "ChannelHeader.module__backButton___THRHU1",
  "wK": "ChannelHeader.module__backButtonDesktop___THRHU1" + " " + "ChannelHeader.module__backButton___THRHU1",
  "j2": "ChannelHeader.module__backIcon___THRHU1",
  "Ir": "ChannelHeader.module__backIconBold___THRHU1" + " " + "ChannelHeader.module__backIcon___THRHU1",
  "CY": "ChannelHeader.module__leftContentContainer___THRHU1",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___THRHU1",
  "BN": "ChannelHeader.module__mobileButton___THRHU1",
  "Vt": "ChannelHeader.module__desktopButton___THRHU1" + " " + "ChannelHeader.module__mobileButton___THRHU1",
  "R3": "ChannelHeader.module__avatarWrapper___THRHU1",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___THRHU1",
  "_D": "ChannelHeader.module__groupDmHeaderInner___THRHU1",
  "ab": "ChannelHeader.module__groupDmEditIcon___THRHU1",
  "HA": "ChannelHeader.module__channelName___THRHU1",
  "$7": "ChannelHeader.module__groupDmChannelName___THRHU1",
  "kf": "ChannelHeader.module__dmNameWrapper___THRHU1",
  "a1": "ChannelHeader.module__userTag___THRHU1",
  "p": "ChannelHeader.module__channelIcon___THRHU1",
  "ml": "ChannelHeader.module__caretRight___THRHU1",
  "Nj": "ChannelHeader.module__channelInfoContainer___THRHU1",
  "u8": "ChannelHeader.module__followButton___THRHU1",
  "B6": "ChannelHeader.module__topicDivider___THRHU1",
  "zm": "ChannelHeader.module__topicContainer___THRHU1",
  "yu": "ChannelHeader.module__topicButton___THRHU1",
  "Am": "ChannelHeader.module__topicButtonOverflow___THRHU1",
  "lY": "ChannelHeader.module__headerRightSection___THRHU1",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___THRHU1",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___THRHU1",
  "gb": "ChannelHeader.module__iconButton___THRHU1",
  "f5": "ChannelHeader.module__iconButtonDefault___THRHU1" + " " + "ChannelHeader.module__iconButton___THRHU1",
  "vR": "ChannelHeader.module__iconButtonSelected___THRHU1" + " " + "ChannelHeader.module__iconButton___THRHU1",
  "rB": "ChannelHeader.module__updateIconButton___THRHU1" + " " + "ChannelHeader.module__iconButton___THRHU1",
  "l_": "ChannelHeader.module__updateIcon___THRHU1",
  "Do": "ChannelHeader.module__updateIconSpinning___THRHU1" + " " + "ChannelHeader.module__updateIcon___THRHU1",
  "bx": "ChannelHeader.module__updateIconSpin___THRHU1",
  "IC": "ChannelHeader.module__iconButtonMobile___THRHU1",
  "iA": "ChannelHeader.module__buttonIcon___THRHU1",
  "qt": "ChannelHeader.module__buttonIconMobile___THRHU1",
  "Dm": "ChannelHeader.module__iconButtonWrapper___THRHU1",
  "W9": "ChannelHeader.module__unreadPinIndicator___THRHU1",
};

module.exports = exports;
